import { UnstyledRACButton } from "../../buttons/UnstyledRACButton";
import { elementCardStyles } from "../ElementCard.css";
import { ElementCardButtonProps } from "./types";

const ElementCardButton = ({
  onPress,
  children,
  isDisabled,
}: ElementCardButtonProps) => (
  <UnstyledRACButton
    onPress={onPress}
    className={elementCardStyles}
    data-pitch-element="true"
    isDisabled={isDisabled}
  >
    {children}
  </UnstyledRACButton>
);

export default ElementCardButton;
